var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#pin-atm';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-pin-atm';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?pin-atm#pin-atm';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?pin-atm#view-pin-atm';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 23 25',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };